import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";
import { unmaskPhone, unmaskCEP } from "../lib/masks";

export default {
  namespaced: true,
  state: {
    Funcionarios: [],
  },
  mutations: {
    carregar(state, Funcionarios) {
      state.Funcionarios = [];
      state.Funcionarios = Funcionarios;
    },
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/funcionarios?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, FuncionarioInfo) {
      try {
        let response;
        const dados = {
          ...FuncionarioInfo,
          telefone: unmaskPhone(FuncionarioInfo.telefone),
          cep: unmaskCEP(FuncionarioInfo.cep),
        };
        if (dados.id == "") {
          delete dados.id;
          response = await securedAxios.post("/funcionarios", dados);
        } else {
          var id = dados.id;
          delete dados.id;
          response = await securedAxios.put("/funcionarios/" + id, dados);
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregarFuncionario(context, id) {
      return securedAxios.get(`/funcionarios/${id}`);
    },
    async deletar(context, id) {
      try {
        const response = await securedAxios.delete("/funcionarios/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
